import React, { useState } from "react";
import { Dialog } from "primereact/dialog";
import { AutoComplete } from "primereact/autocomplete";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import axios from "axios";
import config from "../config";
import { useAuth } from "../context/AuthContext";

const ClientSearchDialog = ({ visible, onHide, onSelectClient }) => {
    const { accessToken } = useAuth();

    // Separate state for each search field
    const [billingName, setBillingName] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [filteredClients, setFilteredClients] = useState([]);
    const [selectedClient, setSelectedClient] = useState(null);

    // Fetch clients based on the type of input field
    const searchClients = async (query, field) => {
        if (!query.trim()) return;

        try {
            const response = await axios.get(`${config.apiBASEURL}/ClientFormRoutes/search-clients`, {
                params: { [field]: query },
                headers: { Authorization: `Bearer ${accessToken}` },
            });

            if (response.status === 200) {
                setFilteredClients(Array.isArray(response.data) ? response.data : []);
            } else {
                setFilteredClients([]);
            }
        } catch (error) {
            console.error("Error fetching clients:", error);
            setFilteredClients([]);
        }
    };

    // Handle Client Selection
    const handleClientSelect = (e) => {
        const client = e.value;
        setSelectedClient(client);
        setBillingName(client.Billing_name || "");
        setEmail(client.email || "");
        setPhone(client.phone || "");
    };

    return (
        <Dialog visible={visible} onHide={onHide} header="Search Client" modal style={{ width: "400px" }}>
            <div className="p-grid p-fluid">
                {/* Billing Name Search */}
                <div className="p-col-12 mb-2">
                    <label className="mb-2">Search by Company Name</label>
                    <AutoComplete
                        value={billingName}
                        suggestions={filteredClients}
                        completeMethod={(e) => searchClients(e.query, "billing_name")}
                        field="Billing_name"
                        itemTemplate={(client) => (
                            <div>
                                <strong>{client.Billing_name}</strong> <br />
                                <small>{client.email} | {client.phone}</small>
                            </div>
                        )}
                        onChange={(e) => setBillingName(e.value)}
                        onSelect={handleClientSelect}
                        placeholder="Type billing name..."
                        
                    />
                </div>

                {/* Email Search */}
                <div className="p-col-12 mb-2">
                    <label className="mb-2">Search by Email</label>
                    <AutoComplete
                        value={email}
                        suggestions={filteredClients}
                        completeMethod={(e) => searchClients(e.query, "email")}
                        field="email"
                        itemTemplate={(client) => (
                            <div>
                                <strong>{client.email}</strong> <br />
                                <small>{client.Billing_name} | {client.phone}</small>
                            </div>
                        )}
                        onChange={(e) => setEmail(e.value)}
                        onSelect={handleClientSelect}
                        placeholder="Type email..."
                        
                    />
                </div>

                {/* Phone Search */}
                <div className="p-col-12 mb-2">
                    <label className="mb-2">Search by Phone</label>
                    <AutoComplete
                        value={phone}
                        suggestions={filteredClients}
                        completeMethod={(e) => searchClients(e.query, "phone")}
                        field="phone"
                        itemTemplate={(client) => (
                            <div>
                                <strong>{client.phone}</strong> <br />
                                <small>{client.Billing_name} | {client.email}</small>
                            </div>
                        )}
                        onChange={(e) => setPhone(e.value)}
                        onSelect={handleClientSelect}
                        placeholder="Type phone..."
                    />
                </div>
            </div>

            {/* Select Button */}
            {selectedClient && (
                <Button label="Select Client and Submit" severity="help" icon="pi pi-check" className="mt-3 py-2 justify-content-end" onClick={() => onSelectClient(selectedClient)} />
            )}
        </Dialog>
    );
};

export default ClientSearchDialog;
